<template>
  <div class="baidu-maps">
    <div class="map-wrapper">
      <div ref="mapContainer" class="baidu-map"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  config: {
    type: Object,
    required: true,
  }
})

const mapContainer = ref(null)
// eslint-disable-next-line no-unused-vars
let mapInstance = null

onMounted(() => {
  if (window.BMap && window.BMap.Map) {
    initMap()
  } else {
    loadBaiduScript()
      .then(() => initMap())
      .catch((e) => console.error('Baidu Maps yüklenemedi:', e))
  }
})

function loadBaiduScript() {
  return new Promise((resolve, reject) => {
    if (window.BMap && window.BMap.Map) {
      resolve()
      return
    }
    if (!window._baiduMapCallbacks) {
      window._baiduMapCallbacks = []
    }
    window._baiduMapCallbacks.push(resolve)

    if (document.getElementById('baidu-script')) {
      return
    }

    window._onBaiduMapCallback = () => {
      window._baiduMapCallbacks.forEach(cb => cb())
      window._baiduMapCallbacks = []
    }

    const script = document.createElement('script')
    script.id = 'baidu-script'
    script.type = 'text/javascript'
    script.src = `https://api.map.baidu.com/api?v=2.0&ak=${props.config.apiKey}&callback=_onBaiduMapCallback`
    script.onerror = reject

    document.body.appendChild(script)
  })
}

function getRouteUrl(endLat, endLng) {
  return `http://api.map.baidu.com/direction?origin=latlng:0,0|name:origin&destination=latlng:${endLat},${endLng}|name:destination&mode=driving&region=none&output=html`
}

function initMap() {
  const { center, zoom, marker } = props.config

  const map = new window.BMap.Map(mapContainer.value)
  mapInstance = map
  const centerPoint = new window.BMap.Point(center.lng, center.lat)
  map.centerAndZoom(centerPoint, zoom || 14)
  map.enableScrollWheelZoom(true)

  const navigationControl = new window.BMap.NavigationControl({
    type: window.BMAP_NAVIGATION_CONTROL_LARGE,
    anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT
  })
  map.addControl(navigationControl)

  const mapTypeControl = new window.BMap.MapTypeControl({
    mapTypes: [window.BMAP_NORMAL_MAP, window.BMAP_SATELLITE_MAP, window.BMAP_HYBRID_MAP]
  })
  map.addControl(mapTypeControl)

  const point = new window.BMap.Point(marker.lng, marker.lat)
  const iconUrl = marker.iconUrl || `https://api.iconify.design/mdi/map-marker.svg?color=${encodeURIComponent(marker.color || '#ff0000')}`
  const icon = new window.BMap.Icon(iconUrl, new window.BMap.Size(32, 32))

  const markerInstance = new window.BMap.Marker(point, { icon })
  map.addOverlay(markerInstance)

  if (marker.title || marker.description || marker.logo || marker.directionsText) {
    const routeUrl = getRouteUrl(marker.lat, marker.lng)
    const infoWindow = new window.BMap.InfoWindow(`
    <div style="text-align: center; font-family: sans-serif; padding: 10px; width: 200px;">
      ${marker.logo ? `<img src="${marker.logo}" alt="logo" style="width: 100px; margin: 0 auto 8px; display: block;" />` : ''}
      ${marker.title ? `<div style="font-weight: bold; font-size: 16px; margin-bottom: 4px; color: #333;">${marker.title}</div>` : ''}
      ${marker.description ? `<div style="font-size: 14px; color: #333;">${marker.description}</div>` : ''}
      <br/>
       <a href="${routeUrl}" target="_blank" style="color: #0066cc; text-decoration: none; font-size: 14px;">
          ${marker.directionsText}
        </a>
    </div>
  `)

    markerInstance.addEventListener('click', () => {
      map.openInfoWindow(infoWindow, point)
    })
  }
}

</script>

<style scoped>
.baidu-map {
  width: 100%;
  height: 500px;
}
</style>
